import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Field, reduxForm, change } from "redux-form";
import {
  InputText,
  Dropdown,
  Loading,
  Valert,
  Vmodal,
  DateTimePicker,
  Validations,
} from "../components";
import { Row, Col, Form, FormGroup } from "reactstrap";
import classNames from "classnames";
import _ from "lodash";

import {
  isLoadedFromMobile,
  getCurrentOrientation,
} from "../services/MobileService";
import { Orientations } from "./PageConstants";

import inboxActions from "../actions/inboxActions";

import {
  REACT_STYLE_BUTTON_SIZE_DESKTOP,
  REACT_STYLE_BUTTON_SIZE_MOBILE,
} from "./Constants";
import "./styles/recipeManagement.css";
import {
  KIT_CAT,
  ACTIVITY_UNITS,
  FOOD_UNITS,
  SYMPTOM_UNITS_NEW,
  DRUG_UNITS,
  PCP_UNITS,
  SUP_UNITS,
  LOC_UNITS,
  INBOX_CAT,
} from "../actions/constant";
import moment from "moment";
import NoDataAlert from "../components/noDataAlert";
class InboxForm extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {};
  }

  render() {
    const { t, inboxForm } = this.props;
    return (
      <Form>
        <FormGroup row>
          <Col>
            <Field
              name="category"
              component={Dropdown}
              options={t("INBOX_CAT", {
                returnObjects: true,
              })}
              onChange={this.props.categorySelected}
              val={inboxForm.category}
            />
          </Col>
          <Col>
            <Field
              name="sortBy"
              component={Dropdown}
              options={[
                { label: t("inbox.NEW_DROPDOWN_OPTION"), value: "new" },
                { label: t("inbox.OLD_DROPDOWN_OPTION"), value: "old" },
                { label: t("inbox.ATOZ_DROPDOWN_OPTION"), value: "ascending" },
                { label: t("inbox.ZTOA_DROPDOWN_OPTION"), value: "descending" },
              ]}
              className="sortBy"
              val={inboxForm.sortBy}
              placeholder={t("recipe_management.SORT_DROPDOWN_PLACEHOLDER")}
              onChange={(e) => {
                this.props.inboxFilter(e.target.value);
              }}
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

InboxForm = reduxForm({
  form: "formInbox",
  onChange: (values, dispatch, props, previousValues) => {
    props.submit();
  },
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(InboxForm);

InboxForm = connect((state) => ({
  initialValues: state.inbox.InboxForm,
}))(InboxForm);

class Inbox extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.ingredientTogglerClick.bind(this);
    this.state = {
      isDeleting: false,
      isEditing: false,
      initcat: "00",
      dlModal: false,
      mPlanDate: moment(),
      shareModal: false,
      redirectCat: "",
    };

    this.acceptClicked = this.acceptClicked.bind(this);
    this.categorySelected = this.categorySelected.bind(this);
  }

  componentDidMount() {
    this.props.initialization();
  }

  ingredientTogglerClick(id, isExpand, isDone) {
    this.props.ingredientToggle(id, isExpand, isDone);
  }

  notifSelectToggle(id) {
    this.props.notifSelectToggle(id);
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.notifs !== "undefined") {
      let selected = 0;
      _.forEach(nextProps.notifs, (notif) => {
        selected += notif.isSelected ? 1 : 0;
      });

      this.setState({ isDeleting: selected > 0 });
      this.setState({ isEditing: selected === 1 });
    }
  }
  categorySelected(e) {
    this.props.categorySelected(e);
    this.myRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }

  handleSubmit(values) {
    if (values && values.sortBy) {
      // this.props.inboxFilter(values.sortBy);
    }
  }

  acceptClicked(e) {
    let redirectCat =
      this.props.notifs[0].category === "02"
        ? "999"
        : this.props.notifs[0].category === "10"
          ? "02"
          : this.props.notifs[0].category;
    this.setState({ redirectCat: redirectCat });
    let ids = [];
    _.forEach(this.props.notifs, (notif) => {
      if (notif.isSelected) {
        ids.push(notif._id);
      }
    });

    this.props.acceptNotifs(ids); //+ "&cat=" + cat
  }

  render() {
    const {
      isLoading,
      status,
      actionResponse,
      t,
      notifsAll,
      notifs,
      disabled,
    } = this.props;

    const deleteClass = classNames("btn", "btn-primary", {
      disabled: !this.state.isDeleting,
    });
    const editClass = classNames("btn", "btn-primary", {
      disabled: !this.state.isEditing,
    });
    var _pageFitter, _btnFontSize;
    if (
      isLoadedFromMobile() ||
      getCurrentOrientation() === Orientations.PORTRAIT
    ) {
      _pageFitter = "page-fitter-mobile";
      _btnFontSize = REACT_STYLE_BUTTON_SIZE_MOBILE;
    } else {
      _pageFitter = "page-fitter";
      _btnFontSize = REACT_STYLE_BUTTON_SIZE_DESKTOP;
    }
    //page-wrapper-notif-management
    return (
      <div>
        <div style={{ minHeight: "auto" }} className="vPage">
          <Loading isLoading={isLoading} />
          <Valert
            display={false}
            title={t("general.DELETE_CONFIRMATION_TITLE")}
            question={t("inbox.DELETE_SELECTED_ITEM_TEXT")}
            onRef={(ref) => (this.deleteValert = ref)}
            positiveAction={() => {
              let ids = [];
              _.forEach(this.props.notifs, (notif) => {
                if (notif.isSelected) {
                  ids.push(notif._id);
                }
              });
              this.props.deleteNotifs(ids);
            }}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
          />
          <Vmodal
            displayStatus={this.props.acceptSuccess}
            data={
              <div className="mb-4">
                <h4>{this.props.t("general.SAVE_SUCCESSFULLY_TITLE")}</h4>
                <p>{this.props.t("inbox.SAVE_INBOX_TEXT")}</p>
              </div>
            }
            closeFunc={() => {
              this.props.clearInbox();
              window.location.href = "/recipemanagement";
            }}
            timedClose={2000}
          />
          <InboxForm
            disabled={disabled}
            onSubmit={this.handleSubmit.bind(this)}
            categorySelected={this.categorySelected.bind(this)}
            t={t}
            inboxForm={this.props.inboxForm}
            myRef={this.myRef}
            selectedItems={this.props.selectedItems}
            inboxFilter={this.props.inboxFilter}
          />
          <div ref={this.myRef} className="recipeList grayList">
            {notifs && notifs.length > 0
              ? typeof notifs.map !== "undefined" &&
              notifs.map((notif, i) => {
                const isExpand =
                  typeof notif.isExpand != "undefined"
                    ? notif.isExpand
                    : false;
                const ingredientTogglerClass = classNames(
                  "fas",
                  { "fa-chevron-down": !isExpand },
                  { "fa-chevron-up": isExpand }
                );
                const ingredientListClass = classNames("ingredient-list1", {
                  expand: isExpand,
                });

                return (
                  <ul className="recipe-item" key={i}>
                    <li className="wrapper">
                      <Row>
                        <Col xs="11">
                          <div className="recipeItemTopSection">
                            <div className="row recipe-item-title">
                              <Col xs="auto" className="no">
                                <div>
                                  {" "}
                                  <br></br>
                                </div>
                                <div className="expand">
                                  <a
                                    className="ingredient-toggle"
                                    onClick={this.ingredientTogglerClick.bind(
                                      this,
                                      notif._id,
                                      isExpand,
                                      notif.isDone
                                    )}
                                  >
                                    <i
                                      className={ingredientTogglerClass}
                                      style={{
                                        fontSize: 14,
                                        verticalAlign: "text-top",
                                        color: "#007bff",
                                      }}
                                    />
                                  </a>
                                </div>
                              </Col>
                              <Col xs="10">
                                <div
                                  className="name"
                                  style={{
                                    fontSize: 13,
                                    wordBreak: "break-word",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                    }}
                                  >
                                    {moment(notif.date).format(
                                      "DD MMM YY, hh:mm a"
                                    )}
                                  </div>
                                  {notif.text}
                                </div>
                              </Col>
                            </div>
                          </div>

                          <div className="recipe-item-desc">
                            <div>
                              {notif.ingredients &&
                                notif.category == "02" &&
                                isExpand && (
                                  <div>
                                    {notif.ingredients &&
                                      notif.ingredients.map((item, j) => {
                                        return (
                                          <div key={j}>
                                            <div
                                              className={ingredientListClass}
                                              style={{
                                                margin: "10px 0",
                                                paddingLeft: "1.5rem",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {item.recipe_full}
                                            </div>
                                            <ul
                                              className={ingredientListClass}
                                              style={{
                                                fontSize: 13,
                                                paddingLeft: "1.5rem",
                                              }}
                                            >
                                              {item.ingredients &&
                                                item.ingredients.map(
                                                  (ingredient, j) => {
                                                    let unitName = "";
                                                    let meas = [];
                                                    let itemUnit =
                                                      ingredient.unitid;

                                                    meas = FOOD_UNITS();

                                                    if (itemUnit) {
                                                      for (const mea of meas) {
                                                        if (
                                                          mea._id == itemUnit
                                                        ) {
                                                          unitName =
                                                            mea.displayunit;
                                                        }
                                                      }
                                                    }

                                                    return (
                                                      <Row key={j}>
                                                        <Col xs="2">
                                                          {ingredient.size}
                                                          {"  "}
                                                          {unitName || ""}
                                                        </Col>
                                                        <Col xs="10">
                                                          {ingredient.fullname ||
                                                            ingredient.recipe_full ||
                                                            ingredient.name}
                                                          {ingredient.upc
                                                            ? ` (${ingredient.upc})`
                                                            : ""}
                                                        </Col>
                                                      </Row>
                                                    );
                                                  }
                                                )}
                                            </ul>
                                            <div
                                              className={ingredientListClass}
                                              style={{
                                                marginLeft: "-24px",
                                                textAlign: "justify",
                                                width: isExpand && "31.6rem",
                                                wordBreak: "break-word",
                                              }}
                                            >
                                              {item.size ? (
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  <span>
                                                    {this.props.t(
                                                      "recipe_management.SERVING_SIZE_TEXT"
                                                    )}
                                                  </span>
                                                  {item.size + ". "}
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                              {item.comment ? (
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      // fontWeight: "bold",
                                                      wordBreak: "break-word",
                                                    }}
                                                  >
                                                    {this.props.t(
                                                      "recipe_management.RECIPE_COMMENT_TEXT"
                                                    )}
                                                  </span>
                                                  {item.comment + ". "}
                                                </span>
                                              ) : (
                                                ""
                                              )}

                                              {/* {`${
                                              item.size
                                                ? this.props.t(
                                                    "recipe_management.SERVING_SIZE_TEXT"
                                                  ) +
                                                  item.size +
                                                  ". "
                                                : ""
                                            }${
                                              item.comment
                                                ? this.props.t(
                                                    "recipe_management.RECIPE_COMMENT_TEXT"
                                                  ) +
                                                  item.comment +
                                                  "."
                                                : ""
                                            }`} */}
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                )}
                              {notif.ingredients &&
                                notif.category != "02" &&
                                isExpand && (
                                  <div
                                    className={ingredientListClass}
                                    style={{ margin: "10px 0" }}
                                  >
                                    {notif.name ? notif.name : ""}
                                  </div>
                                )}
                              <ul
                                className={ingredientListClass}
                                style={{
                                  fontSize: 13,
                                  paddingLeft: "1.5rem",
                                }}
                              >
                                {notif.ingredients &&
                                  notif.category != "02" &&
                                  notif.ingredients.map((ingredient, j) => {
                                    let unitName = "";
                                    let meas = [];
                                    let comment = ingredient.comment
                                      ? ingredient.comment
                                      : null;

                                    if (notif.category == "03") {
                                      meas = ACTIVITY_UNITS();
                                    } else if (notif.category == "01") {
                                      meas = SYMPTOM_UNITS_NEW();
                                    } else if (notif.category == "04") {
                                      meas = PCP_UNITS();
                                    } else if (notif.category == "05") {
                                      meas = DRUG_UNITS();
                                    } else if (
                                      notif.category == "02" ||
                                      notif.category == "10"
                                    ) {
                                      meas = FOOD_UNITS();
                                    } else if (notif.category == "06") {
                                      meas = SUP_UNITS();
                                    } else if (notif.category == "07") {
                                      meas = LOC_UNITS();
                                    }
                                    return (
                                      <div
                                        style={{
                                          width: isExpand && "28.6rem",
                                        }}
                                      >
                                        <Row key={j}>
                                          <Col xs="12">
                                            <div
                                              style={{
                                                margin: "10px 0 10px 0",
                                                fontSize: 14,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {ingredient.fullname ||
                                                ingredient.recipe_full ||
                                                ingredient.recipe}
                                            </div>
                                          </Col>
                                        </Row>

                                        {ingredient.items &&
                                          ingredient.items.map(
                                            (ingredient, j) => {
                                              // Prefer a string id; unit can be an array, a string, or undefined
                                              let itemUnit =
                                                (ingredient.unitid && String(ingredient.unitid)) ||
                                                (Array.isArray(ingredient.unit)
                                                  ? String(ingredient.unit[0] || "")
                                                  : String(ingredient.unit || ""));
                                              if (itemUnit) {
                                                for (const mea of meas) {
                                                  if (mea._id == itemUnit) {
                                                    unitName =
                                                      mea.displayunit;
                                                  }
                                                }
                                              }
                                              return (
                                                <Row key={j}>
                                                  <Col xs="2">
                                                    {ingredient.value ||
                                                      ingredient.size}
                                                    {"  "}
                                                    {unitName || ""}
                                                  </Col>
                                                  <Col xs="10">
                                                    {ingredient.fullname ||
                                                      ingredient.recipe_full ||
                                                      ingredient.name}
                                                    {ingredient.upc
                                                      ? ` (${ingredient.upc})`
                                                      : ""}
                                                    <br />
                                                    {ingredient.ingredients &&
                                                      ingredient.ingredients
                                                        .length > 0 &&
                                                      ingredient.ingredients.map(
                                                        (
                                                          ingredient,
                                                          index
                                                        ) => (
                                                          <div
                                                            style={{
                                                              paddingTop: 5,
                                                            }}
                                                          >
                                                            {meas.map(
                                                              (mea) => {
                                                                if (
                                                                  mea._id ==
                                                                  ingredient.unitid
                                                                ) {
                                                                  unitName =
                                                                    mea.displayunit;
                                                                }
                                                              }
                                                            )}
                                                            <Row>
                                                              <Col xs="2">
                                                                <span>
                                                                  {ingredient.value ||
                                                                    ingredient.size}{" "}
                                                                  {unitName ||
                                                                    ""}
                                                                </span>
                                                              </Col>
                                                              <Col xs="10">
                                                                <span>
                                                                  {ingredient.fullname ||
                                                                    ingredient.recipe_full ||
                                                                    ingredient.name}
                                                                  {ingredient.upc
                                                                    ? ` (${ingredient.upc})`
                                                                    : ""}
                                                                </span>
                                                              </Col>
                                                            </Row>
                                                          </div>
                                                        )
                                                      )}
                                                  </Col>
                                                </Row>
                                              );
                                            }
                                          )}
                                        {comment ? (
                                          <Row key={j}>
                                            <Col
                                              xs="12"
                                              style={{
                                                textAlign: "justify",
                                                wordBreak: "break-word",
                                              }}
                                            >
                                              <span>
                                                {this.props.t(
                                                  "recipe_management.RECIPE_COMMENT_TEXT"
                                                )}{" "}
                                                {comment}
                                              </span>
                                            </Col>
                                          </Row>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    );
                                  })}
                              </ul>
                            </div>
                          </div>
                        </Col>

                        <Col xs="1">
                          <div
                            onClick={this.notifSelectToggle.bind(this, notif)}
                            className="checkmarkContainer"
                          >
                            <input
                              type="checkbox"
                              checked={notif.isSelected ? "checked" : ""}
                            />
                            {notif.isSelected}
                            <span
                              className="checkmark"
                              style={{
                                alignSelf: isExpand ? "baseline" : "center",
                                marginTop:
                                  isExpand && notif.category == "02"
                                    ? "4.5rem"
                                    : isExpand && notif.category != "02"
                                      ? "5.2rem"
                                      : "",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </li>
                  </ul>
                );
              })
              : !isLoading && (
                <NoDataAlert
                  pl={5}
                  text={t("recipe.NO_DATA_SHARED_BOX_TEXT")}
                  bg="transparent"
                />
              )}
          </div>

          <div className="row ">
            <div className="col">
              <button
                className="btn btn-primary btnWide"
                type="button"
                onClick={() => this.deleteValert.changeStatus()}
                disabled={this.props.selectedItems.length <= 0}
              >
                {t("general.DELETE")}
              </button>
            </div>

            <div className="col">
              <button
                className="btn btn-primary btnWide"
                type="button"
                disabled={this.props.selectedItems.length <= 0}
                onClick={(e) => this.acceptClicked()}
              >
                {t("general.ACCEPT_BUTTON")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Inbox = translate("translations")(Inbox);

const mapStateToProps = (state) => ({
  ...state.inbox,
  formInbox: state.form.formInbox,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...inboxActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Inbox);



// WEBPACK FOOTER //
// ./src/pages/Inbox.js